<template>
  <div class="about">
    <b-container class="view-container">
      <b-row>
        <b-col>
          <div v-if="user.isAdmin">
            <hr>
            <div class="text-center">
              <router-link :to="'/om/laes-mer'">
                <mu-raised-button class="demo-raised-button" label="Redigera &quot;Läs mer&quot;" icon="edit" primary />
              </router-link>
            </div>
            <hr>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="aboutText" v-html="aboutText.dynamicTextWebApp" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center" style="color: #ececec">
          <span v-if="versions">{{ versions.backendVersion }}</span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { getApplicationDynamicTextByKey, getVersionInfo } from '../store/actions'

export default {
  name: 'About',
  computed: {
    aboutText () {
      return this.$store.getters.applicationDynamicText('firstPageReadMore')
    },
    versions () {
      return this.$store.getters.versions
    },
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    getApplicationDynamicTextByKey(this.$store, 'firstPageReadMore')
    getVersionInfo(this.$store)
  }
}
</script>

<style lang="scss" scoped>
body .view-container {
  padding-top: 20px;
}
</style>

